import { useThemeStatusStore } from 'store/themeStatus.store';

import { LineChart } from 'components/common/charts/lineChart/lineChart';

import { GraphData } from 'components/widgets/Trends/Trends';
import classes from 'components/widgets/Trends/components/TrendsGraph/TrendsGraph.module.scss';
import { serializeData, serializeOptions } from 'components/widgets/Trends/components/TrendsGraph/TrendsGraph.utils';

interface Props {
    data: GraphData;
    toggleLabels: boolean;
    chartHeight: string | number;
}

export type SingleLineOptions =
    | 'Pre-defined Combinations (Normalized values)'
    | 'Multi Parameters (Normalized values)'
    | 'Single Parameter (Actual value)';

export const TrendsGraph = ({ data, toggleLabels, chartHeight }: Props) => {
    const { themeStatus } = useThemeStatusStore();

    const series = serializeData(data.dataset);
    const graphOptions = serializeOptions({
        series,
        themeStatus,
        toggleLabels,
    });

    return (
        <div className={classes.trendsGraphContainer} data-testid={'trends-graph-container'}>
            <LineChart series={series} options={graphOptions} height={chartHeight ?? 760} />
        </div>
    );
};
